module.exports = __webpack_public_path__ + "static/img/sb_03.7a1b73b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/sb_03.jpg
// module id = xRhc
// module chunks = 0